import { useAuthStore } from '@/store/auth';

// Personalization is a permanent, voluntary entry point. Its visibility must
// not depend on a status request or whether this account completed setup.
export default function usePersonalOnboardingInvitation({ enabled = true } = {}) {
  const userId = useAuthStore(s => s.user?.id);
  const token = useAuthStore(s => s.token);
  const isGhost = useAuthStore(s => s.user?.flags?.isGhost);
  return { visible: !!(enabled && userId && token && !isGhost) };
}
